import {
  GET_RENTAL,
  GET_RENTAL_BY_ID,
  GET_RENTAL_MINE,
} from "../constants/index";

export const buy = (
  state = { getrentallist: [], getrentalbyid: {}, getminerentallist: [] },
  action
) => {
  switch (action.type) {
    case GET_RENTAL:
      return { ...state, getrentallist: action.getrentallist };
    case GET_RENTAL_MINE:
      return { ...state, getminerentallist: action.getminerentallist };
    case GET_RENTAL_BY_ID:
      return { ...state, getrentalbyid: action.getrentalbyid };
    default:
      return state;
  }
};
